import { NavLink } from "react-router-dom";
import { LayoutDashboard, CalendarDays, Car, Users, MoreHorizontal } from "lucide-react";

const MOBILE_ITEMS = [
  { key: "dashboard", label: "Inicio", path: "/dashboard", icon: LayoutDashboard },
  { key: "reservations", label: "Reservas", path: "/reservations", icon: CalendarDays },
  { key: "fleet", label: "Flota", path: "/fleet", icon: Car },
  { key: "customers", label: "Clientes", path: "/customers", icon: Users },
  { key: "settings", label: "Más", path: "/settings", icon: MoreHorizontal },
];

export function BottomNav() {
  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 bg-white border-t border-gray-200 z-40"
      data-testid="bottom-nav"
    >
      <div className="grid grid-cols-5">
        {MOBILE_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.key}
              to={item.path}
              data-testid={`bottomnav-${item.key}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-semibold transition-colors ${
                  isActive ? "text-brand-graphite" : "text-brand-gray/60"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <span
                    className={`flex items-center justify-center h-8 w-8 rounded-md ${
                      isActive ? "bg-brand-yellow" : "bg-transparent"
                    }`}
                  >
                    <Icon className="h-[18px] w-[18px]" strokeWidth={2} />
                  </span>
                  {item.label}
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
